import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";

export default function Header() {
    return (
        <View style={{ flexDirection: "column", marginTop: 6, marginBottom: 10 }}>
            <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <View style={{ width: "48%" }}>
                    <Image style={{ height: 44, width: 165 }} src="/img/LogoRSCS-Black.png" />
                </View>
                <View style={{ width: "52%", alignItems: "flex-end" }}>
                    <Text style={{ fontSize: 8, fontWeight: "bold", textAlign: "right" }}>RS Citra Sundari</Text>
                    <Text style={{ fontSize: 7, textAlign: "right" }}>Jl. Temu Putih 100, Cilegon, Indonesia</Text>
                    <Text style={{ fontSize: 7, textAlign: "right" }}>(0254) 396710</Text>
                    <Text style={{ fontSize: 7, textAlign: "right" }}>rscitrasundari.com</Text>
                </View>
            </View>
            <View style={{ height: 1, backgroundColor: "#111827", marginTop: 8 }} />
        </View>
    );
}

/*
return (
        <div>
            <PDFDownloadLink document={<MyDocument />} fileName="somename.pdf">
                {({ blob, url, loading, error }) => (loading ? "Loading document..." : "Download now!")}
            </PDFDownloadLink>
        </div>
    );


    <View style={{ flexDirection: "row", alignItems: "center" }}>
                <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
                <View>
                    <Text style={{ width: 50, textAlign: "center" }}>Hello</Text>
                </View>
                <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
            </View>
    */
